import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Drawer,
  Descriptions,
  Tag,
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";

const fields = {
  name: {
    header: "Name",
    formatter: (_v, r) => r.name || "NA",
  },

  email: {
    header: "Email",
    formatter: (_v, r) => r.email || "NA",
  },

  city: {
    header: "City",
    formatter: (_v, r) => r.city || "NA",
  },

  zipCode: {
    header: "Zip Code",
    formatter: (_v, r) => r.zipCode || "NA",
  },

  gender: {
    header: "Gender",
    formatter: (_v, r) => r.gender || "NA",
  },

  ageGroup: {
    header: "Age Group",
    formatter: (_v, r) => r.ageGroup || "NA",
  },

  shoppingFrequency: {
    header: "Shopping Frequency",
    formatter: (_v, r) => r.shoppingFrequency || "NA",
  },

  groceryBillOpinion: {
    header: "Grocery Bill Opinion",
    formatter: (_v, r) => r.groceryBillOpinion || "NA",
  },

  recentPurchaseStatement: {
    header: "Recent Purchase Statement",
    formatter: (_v, r) => r.recentPurchaseStatement || "NA",
  },

  reducedPurchasesStatement: {
    header: "Reduced Purchases Statement",
    formatter: (_v, r) => r.reducedPurchasesStatement || "NA",
  },

  topOfMindBrand: {
    header: "Top Of Mind Brand",
    formatter: (_v, r) => r.topOfMindBrand || "NA",
  },

  additionalBrands: {
    header: "Additional Brands",
    formatter: (_v, r) => r.additionalBrands || "NA",
  },

  brandsHeardOf: {
    header: "Brands Heard Of",
    formatter: (_v, r) => r.brandsHeardOf || "NA",
  },

  brandsConsumed: {
    header: "Brands Consumed",
    formatter: (_v, r) => r.brandsConsumed || "NA",
  },

  brandsConsumedMostly: {
    header: "Brands Consumed Mostly",
    formatter: (_v, r) => r.brandsConsumedMostly || "NA",
  },

  brandSelectionReasons: {
    header: "Brand Selection Reasons",
    formatter: (_v, r) =>
      r.brandSelectionReasons
        ? `
Attractive Packaging: ${r.brandSelectionReasons?.attractivePackaging || "NA"}
Best Prices / Promos: ${r.brandSelectionReasons?.bestPricesPromos || "NA"}
Instore Posters: ${r.brandSelectionReasons?.instorePosters || "NA"}
Easily Available: ${r.brandSelectionReasons?.easilyAvailable || "NA"}
Premium Quality: ${r.brandSelectionReasons?.premiumQuality || "NA"}
Social Media Ads: ${r.brandSelectionReasons?.socialMediaAds || "NA"}
Convenient Pack Size: ${r.brandSelectionReasons?.convenientPackSize || "NA"}
`
        : "NA",
  },

  purchaseIntent: {
    header: "Purchase Intent",
    formatter: (_v, r) =>
      r.purchaseIntent
        ? `
Laxmi: ${r.purchaseIntent?.laxmi || "NA"}
Aashirvaad: ${r.purchaseIntent?.aashirvaad || "NA"}
Deep: ${r.purchaseIntent?.deep || "NA"}
Meharban: ${r.purchaseIntent?.meharban || "NA"}
Swad: ${r.purchaseIntent?.swad || "NA"}
Shan: ${r.purchaseIntent?.shan || "NA"}
`
        : "NA",
  },

  recommendationScore: {
    header: "Recommendation Score",
    formatter: (_v, r) =>
      r.recommendationScore
        ? `
Laxmi: ${r.recommendationScore?.laxmi || "NA"}
Deep: ${r.recommendationScore?.deep || "NA"}
Swad: ${r.recommendationScore?.swad || "NA"}
Shan: ${r.recommendationScore?.shan || "NA"}
`
        : "NA",
  },

  qualityRating: {
    header: "Quality Rating",
    formatter: (_v, r) =>
      r.qualityRating
        ? `
Laxmi: ${r.qualityRating?.laxmi || "NA"}
Deep: ${r.qualityRating?.deep || "NA"}
Shan: ${r.qualityRating?.shan || "NA"}
Swad: ${r.qualityRating?.swad || "NA"}
`
        : "NA",
  },

  priceRating: {
    header: "Price Rating",
    formatter: (_v, r) =>
      r.priceRating
        ? `
Laxmi: ${r.priceRating?.laxmi || "NA"}
Deep: ${r.priceRating?.deep || "NA"}
Shan: ${r.priceRating?.shan || "NA"}
Swad: ${r.priceRating?.swad || "NA"}
`
        : "NA",
  },

  voucherCode: {
    header: "Voucher Code",
    formatter: (_v, r) => r.voucherCode || "NA",
  },

  isDuplicate: {
    header: "Duplicate Entry",
    formatter: (_v, r) => (r.isDuplicate ? "Yes" : "No"),
  },

  createdAt: {
    header: "Created At",
    formatter: (_v, r) => (r.createdAt ? helper.ISTDate(r.createdAt) : "NA"),
  },
};

function GrocerySurvey() {
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const moduleNamePural = "Laxmi Grocery Survey 2026";

  const base_url = config.api_url + "admin/leads/grocery-survey";

  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      setData(data);
      setDrawerOpen(true);
    }
  };

  const handleDrawerClose = () => {
    setData({});
    setDrawerOpen(false);
  };

  const fetchDatas = async () => {
    setLoading(true);

    const res = await http.get(base_url);

    if (res) {
      const formatted = res.data.map((item) => ({
        ...item,
        duplicate_text: item.isDuplicate ? "Yes" : "No",
      }));

      setDatas(formatted);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => record.name || "NA",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Voucher Code",
      dataIndex: "voucherCode",
      render: (_, record) => {
        if (record.hasVoucher && record.voucherCode) {
          return <Tag color="green">{record.voucherCode}</Tag>;
        }

        return "NA";
      },
    },
    {
      title: "Is this Duplicate Entry?",
      render: (_, record) => (record.isDuplicate ? "Yes" : "No"),
    },
    {
      title: "Created At",
      render: (_, record) => helper.ISTDate(record.createdAt),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleView(record._id)}>View Detail</Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <Card title={moduleNamePural}>
            <Table
              rowKey={(record) => record._id}
              columns={columns}
              dataSource={datas}
              loading={loading}
              searchable
              pagination={{
                ...pagination,
                total: datas.length,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                onChange: (page, pageSize) => {
                  setPagination({
                    current: page,
                    pageSize,
                  });
                },
              }}
              exportableProps={{
                showColumnPicker: true,
                fields,
                fileName: moduleNamePural,
              }}
            />
          </Card>

          <Drawer
            title="Survey Details"
            placement="right"
            onClose={handleDrawerClose}
            visible={drawerOpen}
            size="large"
          >
            {data && (
              <Descriptions
                bordered
                column={1}
                labelStyle={{
                  width: "55%",
                }}
                contentStyle={{
                  width: "45%",
                }}
              >
                <Descriptions.Item label="Name">
                  {data.name || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Email">
                  {data.email || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="City">
                  {data.city || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Zip Code">
                  {data.zipCode || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Gender">
                  {data.gender || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Age Group">
                  {data.ageGroup || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Shopping Frequency">
                  {data.shoppingFrequency || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Grocery Bill Opinion">
                  {data.groceryBillOpinion || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Recent Purchase Statement">
                  {data.recentPurchaseStatement || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Reduced Purchases Statement">
                  {data.reducedPurchasesStatement || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Top Of Mind Brand">
                  {data.topOfMindBrand || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Additional Brands">
                  {data.additionalBrands || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Brands Heard Of">
                  {data.brandsHeardOf || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Brands Consumed">
                  {data.brandsConsumed || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Brands Consumed Mostly">
                  {data.brandsConsumedMostly || "NA"}
                </Descriptions.Item>

                <Descriptions.Item label="Brand Selection Reasons">
                  <div>
                    <div>
                      Attractive Packaging:{" "}
                      {data.brandSelectionReasons?.attractivePackaging || "NA"}
                    </div>
                    <div>
                      Best Prices / Promos:{" "}
                      {data.brandSelectionReasons?.bestPricesPromos || "NA"}
                    </div>
                    <div>
                      Instore Posters:{" "}
                      {data.brandSelectionReasons?.instorePosters || "NA"}
                    </div>
                    <div>
                      Easily Available:{" "}
                      {data.brandSelectionReasons?.easilyAvailable || "NA"}
                    </div>
                    <div>
                      Premium Quality:{" "}
                      {data.brandSelectionReasons?.premiumQuality || "NA"}
                    </div>
                    <div>
                      Social Media Ads:{" "}
                      {data.brandSelectionReasons?.socialMediaAds || "NA"}
                    </div>
                    <div>
                      Convenient Pack Size:{" "}
                      {data.brandSelectionReasons?.convenientPackSize || "NA"}
                    </div>
                  </div>
                </Descriptions.Item>

                <Descriptions.Item label="Purchase Intent">
                  <div>
                    <div>Laxmi: {data.purchaseIntent?.laxmi || "NA"}</div>
                    <div>
                      Aashirvaad: {data.purchaseIntent?.aashirvaad || "NA"}
                    </div>
                    <div>Deep: {data.purchaseIntent?.deep || "NA"}</div>
                    <div>Meharban: {data.purchaseIntent?.meharban || "NA"}</div>
                    <div>Swad: {data.purchaseIntent?.swad || "NA"}</div>
                    <div>Shan: {data.purchaseIntent?.shan || "NA"}</div>
                  </div>
                </Descriptions.Item>

                <Descriptions.Item label="Recommendation Score">
                  <div>
                    <div>Laxmi: {data.recommendationScore?.laxmi || "NA"}</div>
                    <div>Deep: {data.recommendationScore?.deep || "NA"}</div>
                    <div>Swad: {data.recommendationScore?.swad || "NA"}</div>
                    <div>Shan: {data.recommendationScore?.shan || "NA"}</div>
                  </div>
                </Descriptions.Item>

                <Descriptions.Item label="Quality Rating">
                  <div>
                    <div>Laxmi: {data.qualityRating?.laxmi || "NA"}</div>
                    <div>Deep: {data.qualityRating?.deep || "NA"}</div>
                    <div>Shan: {data.qualityRating?.shan || "NA"}</div>
                    <div>Swad: {data.qualityRating?.swad || "NA"}</div>
                  </div>
                </Descriptions.Item>

                <Descriptions.Item label="Price Rating">
                  <div>
                    <div>Laxmi: {data.priceRating?.laxmi || "NA"}</div>
                    <div>Deep: {data.priceRating?.deep || "NA"}</div>
                    <div>Shan: {data.priceRating?.shan || "NA"}</div>
                    <div>Swad: {data.priceRating?.swad || "NA"}</div>
                  </div>
                </Descriptions.Item>

                <Descriptions.Item label="Voucher Code">
                  {data.hasVoucher && data.voucherCode ? (
                    <Tag color="green">{data.voucherCode}</Tag>
                  ) : (
                    "NA"
                  )}
                </Descriptions.Item>

                <Descriptions.Item label="Is this Duplicate Entry?">
                  {data.isDuplicate ? "Yes" : "No"}
                </Descriptions.Item>

                <Descriptions.Item label="Created At">
                  {helper.ISTDate(data.createdAt)}
                </Descriptions.Item>
              </Descriptions>
            )}
          </Drawer>
        </Col>
      </Row>
    </div>
  );
}

export default GrocerySurvey;
